const contextedRequire = require.context('.', false, /.event.js$/)

const events = {}
contextedRequire.keys().forEach(filename => {
  const event = contextedRequire(filename).default
  events[event.id] = event
})

export default events
